import React from 'react'

function PropertyCard({property}) {
  return (
    <div className="box box-dream hv-one style-dream wg-box">
      <div className="image-group relative ">
        {property.isSponsored && (
          <span className="featured fs-12 fw-6">Sponsorisé</span>
        )}
        <span className="icon-bookmark">
          <i className="far fa-bookmark"></i>
        </span>
        <div className="swiper-container carousel-2 img-style">
          <a href={"/properties/" + property.id} className="icon-plus">
            <img src="/assets/images/icon/plus.svg" alt="images" />
          </a>
          <div className="swiper-wrapper ">
            <div className="swiper-slide">
              <img src="/assets/images/house/featured-1.jpg" alt="images" />
            </div>
            <div className="swiper-slide">
              <img src="/assets/images/house/featured-2.jpg" alt="images" />
            </div>
            <div className="swiper-slide">
              <img src="/assets/images/house/featured-3.jpg" alt="images" />
            </div>
            <div className="swiper-slide">
              <img src="/assets/images/house/featured-4.jpg" alt="images" />
            </div>
            <div className="swiper-slide">
              <img src="/assets/images/house/featured-5.jpg" alt="images" />
            </div>
          </div>
          <div className="pagi2">
            <div className="swiper-pagination2"> </div>
          </div>
          <div className="swiper-button-next2 ">
            <i className="fal fa-arrow-right"></i>
          </div>
          <div className="swiper-button-prev2 ">
            <i className="fal fa-arrow-left"></i>
          </div>
        </div>
      </div>
      <div className="content">
        <h3 className="link-style-1">
          <a href={"/properties/" + property.id}>{property.name}</a>
        </h3>
        <div className="text-address">
          <p className="p-12">{property.address}</p>
        </div>
        <div className="money fs-18 fw-6 text-color-3">
          <a href={"/properties/" + property.id}>€{property.price}</a>
        </div>
        <div className="icon-box flex">
          <div className="icons icon-1 flex">
            <span>Lits: </span>
            <span className="fw-6">{property.numBeds}</span>
          </div>
          <div className="icons icon-2 flex">
            <span>Douches: </span>
            <span className="fw-6">{property.numBaths}</span>
          </div>
          <div className="icons icon-3 flex">
            <span>Superficie: </span>
            <span className="fw-6">{property.perimeter}</span>
          </div>
        </div>
        <div className="days-box flex justify-space align-center">
          <a
            href={"/properties/" + property.id}
            className="compare flex align-center fw-6"
          >
            Visiter
          </a>
          <div className="img-author hv-tool" data-tooltip="Kathryn Murphy">
            <img src="/assets/images/author/author-1.jpg" alt="images" />
          </div>
          <div className="days">{property.publicationDate}</div>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard